import { useDataContext } from 'src/contexts';
import { useSendAnalyticsEvent } from './analytics';

const postHogEventName = 'pvo_media_preview';

export const useTogglePreview = () => {
  const isPreview = useDataContext((ctx) => ctx.isPreview ?? false);
  const setIsPreview = useDataContext((ctx) => ctx.setIsPreview);
  const { sendEvent } = useSendAnalyticsEvent();

  const togglePreview = () => {
    const newIsPreview = !isPreview;
    setIsPreview(newIsPreview);
    if (newIsPreview) {
      sendEvent(postHogEventName);
    }
  };

  return {
    isPreview,
    togglePreview,
  };
};
